import { memo } from "react";

function Loader({ message = "Loading..." }) {
    return (
        <div className="flex items-center justify-center text-center">
            <div
                className="inline-block w-6 h-6 border-2 border-current border-t-transparent rounded-full animate-spin"
                style={{ color: "var(--doc-natural-primary-color)" }}
                role="status"
                aria-label="loading"
            />
            <div className="ml-4 loader-dots">{message}</div>
        </div>
    );
}

export default memo(Loader);
